<template>
  <div class="home-sns-team-select-pane">
    <team-select-list-section
      :listData="teams"
      :selectedID="selectedID"
      @selectChange="changeSelected"
    />
    <action-buttons-section
      scrollTargetSelector=".home-sns-team-select-page__content"
      :visible="true"
    >
      <atom-input-button
        :linkText="$tc('common.set')"
        :isDisabled="false"
        @push="changeSnsPostDisplayTeam"
      />
    </action-buttons-section>
  </div>
</template>

<script lang="ts">
import { defineComponent, Ref } from '@vue/composition-api'
import TeamSelectListSection from '@/components/MypageFavoriteTeamSelectPage/MypageFavoriteTeamSelectPane/TeamSelectListSection.vue'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'
import TeamDocument from '@/store/stores/collectionModule/documents/team/TeamDocument'
import StoreUtil from '@/store/StoreUtil'

export type DataType = {
  selectedID: string
}

/**
 * HOME: SNS投稿表示チーム変更 コンテンツペイン
 */
export default defineComponent({
  name: 'HomeSnsTeamSelectPane',
  components: {
    TeamSelectListSection,
    ActionButtonsSection,
    AtomInputButton,
  },
  data(): DataType {
    return {
      /**
       * セレクトID
       */
      selectedID: '',
    }
  },
  setup() {
    const store = StoreUtil.useStore('HomePageStore')
    const mypagePageStore = StoreUtil.useStore('MypagePageStore')

    return {
      teams: store.availableTeams as Ref<TeamDocument[]>,
      snsPostDisplayTeam: store.snsPostDisplayTeam,
      favoriteTeam: mypagePageStore.favoriteTeam,
    }
  },
  mounted() {
    this.selectedID = this.snsPostDisplayTeam?.sid || ''
  },
  methods: {
    changeSnsPostDisplayTeam() {
      /**
       * SNS投稿を表示するチームをストアに保存
       */
      const selectedTeam = this.teams.find((item) => item.sid === this.selectedID)
      if (selectedTeam) {
        this.snsPostDisplayTeam = selectedTeam
      }

      this.$emit('changed')
    },
    changeSelected(selectedItemID: string): void {
      /**
       * 選択変更
       * @param selectedItemID : string
       */
      if (this.selectedID !== selectedItemID) {
        this.selectedID = this.selectedID === selectedItemID ? '' : selectedItemID
      }
    },
  },
})
</script>

<style lang="scss" scoped>
.home-sns-team-select-pane {
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  height: calc(#{$mypageContentHeightHasSubHeader} - #{var(--safe-area-inset-bottom)});
  padding: 24px 0 104px;
  margin: 0 auto;
  text-align: center;
  overflow-y: auto;
  overflow-x: hidden;

  &__action-buttons {
    bottom: 0;
  }
}
</style>
